import { Grid } from '@mui/material';
import { Button } from '../Button';
import COLORS from '../../colors';
import { useNavigate } from 'react-router-dom';

interface BottomNavigationProps {
  showBackNavigation?: boolean;
  showNextNavigation?: boolean;
  onClick?: () => boolean;
  nextTo: string;
}
const BottomNavigation = ({
  showBackNavigation = true,
  showNextNavigation = true,
  onClick,
  nextTo
}: BottomNavigationProps) => {
  const navigate = useNavigate();

  const handleOnClick = () => {
    let isError = true;
    if (onClick) {
      isError = onClick();
    }

    if (!isError) {
      navigate(nextTo);
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  };

  return (
    <Grid container rowSpacing={1} columnSpacing={{ xs: 1 }}>
      <Grid item xs={6}>
        {showBackNavigation && (
          <Button
            label="Back"
            backgroundColor={COLORS.NEUTRAL_900}
            hoverBackgroundColor={COLORS.BUTTON_SECONDARY_HOVER}
            textColor={COLORS.PRIMARY_500}
          />
        )}
      </Grid>
      <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }} item xs={6}>
        {showNextNavigation && (
          <Button
            label="Next"
            backgroundColor={COLORS.PRIMARY_500}
            hoverBackgroundColor={COLORS.BUTTON_PRIMARY_HOVER}
            textColor={COLORS.PRIMARY_800}
            onClick={handleOnClick}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default BottomNavigation;
